import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { EvaluationCriteria } from '../models/interfaces';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EvaluationCriteriaService {
  slugPosibleFatiga: string = 'posible-fatiga'; // evento especial

  private evaluationCriteriaListSubject: BehaviorSubject<EvaluationCriteria[]> =
    new BehaviorSubject<EvaluationCriteria[]>([]);
  opcionesDropDown: any = [];

  constructor(private http: HttpClient) {}

  public initEvaluationCriteria(): Observable<EvaluationCriteria[]> {
    return this.http
      .get<ResponseInterface>(
        environment.apiUrl + '/api/userEvaluationCriterions'
      )
      .pipe(
        map((criteriosResponse: ResponseInterface) => {
          const criterios = criteriosResponse.data as EvaluationCriteria[];
          this.evaluationCriteriaListSubject.next(criterios);

          const slugs = this.getSlugsFromCriterios();

          // Asigna las opciones del dropdown para cada slug
          slugs.forEach((slug) => {
            this.opcionesDropDown[slug] = this.getDropdownOptionsBySlug(slug); // Llama a la función que obtiene las opciones para cada slug
          });
          // console.log("efrain dropdown",this.opcionesDropDown)

          return criterios;
        }),
        catchError((erro: HttpErrorResponse) => {
          // Manejo del error
          console.error('Error ocurrido:', erro);
          // Puedes devolver un Observable vacío o un valor alternativo
          // Si no deseas que falle el flujo, puedes retornar un valor predeterminado
          return of([]); // Retorna un array vacío en caso de error
        })
      );
  }
  // Obtener el valor actual del BehaviorSubject
  private get evaluationCriteriaList(): EvaluationCriteria[] {
    return this.evaluationCriteriaListSubject.value;
  }

  public getSlugsFromCriterios(): string[] {
    const slugs = this.evaluationCriteriaList.map((criterio) => criterio.slug);

    // Filtrar los slugs únicos
    const uniqueSlugs = slugs.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    return uniqueSlugs;
  }

  public getCriteriaPosibleFatiga(): EvaluationCriteria[] {
    return this.evaluationCriteriaList.filter(
      (criteria) => criteria.slug === this.slugPosibleFatiga
    );
  }

  public isPosibleFatiga(criterioId: string): boolean {
    const criteriosFatiga = this.getCriteriaPosibleFatiga();
    return criteriosFatiga.some(
      (criterio) =>
        criterio.id === criterioId &&
        criterio.parent_name === 'SEÑALES DE POSIBLE FATIGA'
    );
  }

  public isCriteriaConfirmed(criterioId: string): boolean {
    return this.evaluationCriteriaList.some(
      (criterio) => criterio.id === criterioId && criterio.is_confirmed
    );
  }

  public getCriteriaBySlug(slug: string): EvaluationCriteria[] {
    return this.evaluationCriteriaList
      .filter((criteria) => criteria.slug === slug)
      .sort((a, b) =>
        a.is_name_parent_equal === b.is_name_parent_equal
          ? 0
          : a.is_name_parent_equal
          ? -1
          : 1
      );
  }

  public getDropdownOptionsBySlug(slug: string) {
    let criterios = this.getCriteriaBySlug(slug);
    if (criterios.length === 0) {
      criterios = this.getCriteriaPosibleFatiga();
    }

    let groupedByParentName: Record<
      string,
      { items: { label: string; value: string }[] }
    > = {};

    criterios.forEach((criterio) => {
      if (!groupedByParentName[criterio.parent_name]) {
        groupedByParentName[criterio.parent_name] = { items: [] };
      }

      groupedByParentName[criterio.parent_name].items.push({
        label: criterio.name,
        value: criterio.id,
      });
    });

    return Object.keys(groupedByParentName).map((parentName) => ({
      label: parentName,
      items: groupedByParentName[parentName].items,
    }));
  }

  public getOptionBySlug(slug: string) {
    return this.opcionesDropDown[slug];
  }
  public getAll(): EvaluationCriteria[] {
    return this.evaluationCriteriaList;
  }

  public getByEvent(eventSlug: string): EvaluationCriteria[] {
    return this.evaluationCriteriaList.filter(
      (criteria) => criteria.parent_name === eventSlug
    );
  }

  public getById(criterioId: string): EvaluationCriteria | undefined{
    return this.evaluationCriteriaList
      .find((criteria) => criteria.id === criterioId)
  }
}
